<template>
  <generic-modal :modal-key="'resubscribe_game_sms'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_resubscribe_game_sms_you_are_not }}</h1>
        <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
        <p>{{ getTranslations.home_modals_resubscribe_game_sms_in_order_to }}</p>
        <div class="modal__footer"><span class="terms ">
          {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_resub_resubscribe_gamesms_modal') }}
        </span>
        </div>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  // modal_unsubscribe_newgame_store_SMS.html
  name: 'resubscribe-game-sms',
  components: { GenericModal },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGameSms.vue